module.exports = __webpack_public_path__ + "img/teaser_iwpz_2019.491c4c6e.jpg";